export default __webpack_public_path__ + "static/media/63.7e29d54a.jpeg";